module.exports = __webpack_public_path__ + "assets/Portugese.dbc7d83b31b4c7978e97c6fb2b7284c0.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/Portugese.png
// module id = 627
// module chunks = 0